export enum SurveyStates {
  inProgress,
  complete,
  expired,
  answered,
  notFound,
  error,
  back,
}
